<template>
    <div class="header-box">
        <div class="header">
            <div class="header-content">
                <img :src="groupLogo" class="logo-img">
                <div class="group-logo">
                    <img src="../assets/images/Group.png" alt="" class="" @click="showPopup">    
                </div>       
            </div>  
            <van-popup v-model="show" position="right" class="popup-nav">
                <ul class="nav-ul">
                    <li class="nav-li" :class="{'active':/index/.test(this.$route.path)}"><router-link class="nav-link" tag="div" to="/index.html">首页</router-link></li>
                    <li class="nav-li" :class="{'active':item.flag}" v-for="(item,index) in menusList" :key="index">
                        <div v-if="item.subItems.length>0">
                            <router-link  class="nav-link" tag="div" :to="{path:item.subItems[0].link+'.html'}">{{item.alias}}</router-link>
                        </div>
                        <div v-else>
                            <router-link  class="nav-link" tag="div" :to="{path:item.link+'.html'}">{{item.alias}}</router-link>
                        </div>
                    </li>
                </ul>
            </van-popup>          
        </div> 
    </div> 
</template>

<script>
import { Popup } from 'vant';
export default {
    components:{
        [Popup.name]:Popup
    },
    data() {
        return {
            show: false,
            flag:false,
            navActive:[
                {url:'groupNews',flag:false},
                {url:'jobOffers',flag:true},
                {url:'doctors',flag:false},
                {url:'college',flag:false},
                {url:'aboutUs',flag:false},
           ]
        };
    },
    computed:{
        groupLogo(){
            return this.$store.getters.getGroupLogo;
        },
        menusList(){
            return this.$store.getters.getMenusList;
        }
    },
    created(){
       this.getMenuList();
    },
    methods:{
        getMenuList(){
            this.$axios.post(this.api.index.menus,{},res =>{
                var menusData=res.data;
                var matchUrl;
                for(var i in menusData){
                    // if(menusData[i].subItems.length>0){
                    //     matchUrl=menusData[i].subItems[0].link;
                    // }
                    // else{
                        matchUrl=menusData[i].link;
                    // }
                    if(this.$route.path.indexOf(matchUrl) != -1){
                        menusData[i].flag=true;
                    }
                    else{
                        menusData[i].flag=false;
                    }
                }
                //this.menusList=menusData;
                this.$store.dispatch('setMenusList',menusData);
                this.flag=true;
            },err =>{
                //this.menusList=[];
                this.$store.dispatch('setMenusList',[]);
            });
        },
        showPopup() {
            this.show = !this.show;
        },
    }
};
</script>
<style scoped lang="less">
.header-box{
    height:50px;
    .header-content{
        width:100%;height:50px;padding:10px 16px;position: fixed;z-index:9999;background:#fff;
        box-shadow:0px 1px 0px 0px rgba(235,235,237,1);
        .logo-img{
            width:180px;height:30px;position: absolute;left:16px;top:10px;
        }
        .group-logo{
            width:50px;height:50px;position: absolute;right:16px;top:0;padding:15px;
            img{width:20px;height:20px;vertical-align: top;}
        }
    }
    .popup-nav{
        width:240px;height:100%;padding-top:50px;
        .nav-ul{
            padding:0 16px;
            font-size:16px;
            font-weight:400;
            color:rgba(51,51,51,1);
            .nav-li{
                height:54px;
                line-height:54px;
                box-shadow:0px 0px 0px 0px rgba(235,235,237,1);
            }
            .nav-li.active{color:#0D3482;}
        }
    }
}

</style>



// WEBPACK FOOTER //
// src/components/HeaderChild.vue